import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import SubFooterNavigation from '../../containers/sub-footer-navigation';
import Html from '../../containers/html';

const SubFooterNavigationBlock = props => <SubFooterNavigation {...props} />;
SubFooterNavigationBlock.displayName = 'SubFooterNavigation';

export default withDynamicComponents({
  componentWhitelist: [
    Html,
  ],
  mapInputToOutput: [
    ['components', 'children'],
  ],
})(SubFooterNavigationBlock);



// WEBPACK FOOTER //
// ./src/blocks/sub-footer-navigation/index.jsx